(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-shop-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Entrance animations ── */
  var sid = document.querySelector('[data-section-id]');
  if (sid) {
    var heading    = sid.querySelector('.shop__heading');
    var subheading = sid.querySelector('.shop__subheading');
    if (heading)    setTimeout(function(){ heading.classList.add('in-view'); }, 100);
    if (subheading) setTimeout(function(){ subheading.classList.add('in-view'); }, 300);
  }

  var grid       = document.getElementById('shop-grid');
  var search     = document.getElementById('shop-search');
  var countEl    = document.getElementById('shop-count');
  var noResults  = document.getElementById('shop-no-results');
  var filterBtns = document.querySelectorAll('.shop__filter-pill');
  var viewBtns   = document.querySelectorAll('.shop__view-btn');

  /* ── Read filter from URL on load ── */
  var urlParams    = new URLSearchParams(window.location.search);
  var urlFilter    = urlParams.get('filter') || 'all';
  var activeFilter = urlFilter;
  var activeSearch = '';

  /* Apply URL filter to buttons immediately */
  filterBtns.forEach(function(b) {
    b.classList.remove('shop__filter-pill--active');
    if (b.dataset.filter === activeFilter) b.classList.add('shop__filter-pill--active');
  });

  /* ── Filter click — update URL + apply ── */
  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('shop__filter-pill--active'); });
      btn.classList.add('shop__filter-pill--active');
      activeFilter = btn.dataset.filter;

      /* Update URL without page reload */
      var params = new URLSearchParams(window.location.search);
      if (activeFilter === 'all') {
        params.delete('filter');
      } else {
        params.set('filter', activeFilter);
      }
      var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.history.pushState({ filter: activeFilter }, '', newUrl);

      applyFilters();
    });
  });

  if (search) {
    search.addEventListener('input', function () {
      activeSearch = this.value.trim().toLowerCase();
      applyFilters();
    });
  }

  /* Handle browser back/forward */
  window.addEventListener('popstate', function(e) {
    var params = new URLSearchParams(window.location.search);
    activeFilter = params.get('filter') || 'all';
    filterBtns.forEach(function(b) {
      b.classList.remove('shop__filter-pill--active');
      if (b.dataset.filter === activeFilter) b.classList.add('shop__filter-pill--active');
    });
    applyFilters();
  });

  function applyFilters() {
    var cards   = grid ? grid.querySelectorAll('.shop-card') : [];
    var visible = 0;
    cards.forEach(function (card) {
      var handles = (card.dataset.handle || '').split(' ');
      var name    = card.dataset.name || '';
      var matchFilter = activeFilter === 'all' || handles.indexOf(activeFilter) !== -1;
      var matchSearch = !activeSearch || name.indexOf(activeSearch) !== -1;
      if (matchFilter && matchSearch) { card.style.display = ''; visible++; }
      else { card.style.display = 'none'; }
    });
    if (countEl) countEl.textContent = 'Showing ' + visible + ' product' + (visible !== 1 ? 's' : '');
    if (noResults) noResults.hidden = visible > 0;
  }

  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      viewBtns.forEach(function (b) { b.classList.remove('shop__view-btn--active'); });
      btn.classList.add('shop__view-btn--active');
      if (grid) grid.setAttribute('data-view', btn.dataset.view);
    });
  });

  /* Apply URL filter on initial page load */
  applyFilters();

  var wl = JSON.parse(localStorage.getItem('shop_wl') || '[]');
  document.querySelectorAll('.js-wishlist').forEach(function (btn) {
    var id = btn.dataset.id;
    if (wl.indexOf(id) !== -1) btn.classList.add('shop-card__wishlist--active');
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var idx = wl.indexOf(id);
      if (idx === -1) { wl.push(id); btn.classList.add('shop-card__wishlist--active'); }
      else { wl.splice(idx, 1); btn.classList.remove('shop-card__wishlist--active'); }
      localStorage.setItem('shop_wl', JSON.stringify(wl));
    });
  });

  document.querySelectorAll('.js-atc-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn  = form.querySelector('button[type="submit"]');
      var vid  = form.querySelector('input[name="id"]').value;
      var orig = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '✓ Added';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () { btn.disabled = false; btn.innerHTML = orig; }, 1600);
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Error — try again'; });
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
